
export default {
  props: {
    page: Object
  }
}
